import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA from "react-ga4"
import { DREAM_CAFE_PATH, mountDreamCafe } from './dreamCafe';
import { RESUME_PATH, mountResume } from './resume';

// Analytics must never take the page down (it throws without a measurement ID, e.g. locally).
try {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS ?? "")
  ReactGA.send({
    hitType: 'pageview',
    page: window.location.pathname,
  })
} catch (err) {
  console.warn('Analytics disabled:', err)
}

if (DREAM_CAFE_PATH.test(window.location.pathname)) {
  mountDreamCafe();
} else if (RESUME_PATH.test(window.location.pathname)) {
  mountResume();
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
